import axios from 'axios';
import { API_URL } from '../const';
import LeaveRestrictionTypes from './leaveRestriction.types';
import { encryptData } from '../_common/enode-decode';
import { makeApiCall } from '../_common/api.utils';

export const fetchLeaveRestrictions = async (payload: { organisationID: string }) => {
	try {
		const URL = `${API_URL}getAllRestrictedLeaves`;
		const token = encryptData(
			payload,
			LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_KEY as any,
		);
		const requestData = { GetAllRestrictedLeavesToken: token } as any;
		return makeApiCall(URL, requestData);
	} catch (error: any) {
		console.error('Error in fetchLeaveRestrictions:', error);
		throw new Error(
			error.response?.data?.message_text ||
				error.message ||
				'Failed to fetch leave restrictions',
		);
	}
};

export const createLeaveRestriction = async (data: {
	restrictLeaveDate: string;
	Reason: string;
	createdBy?: number;
	isPublish?: number;
}) => {
	try {
		const URL = `${API_URL}createRestrictedLeave`;
		const token = encryptData(data, LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_KEY as any);
		const requestData = { CreateRestrictedLeaveToken: token } as any;
		return makeApiCall(URL, requestData);
	} catch (error: any) {
		console.error('Error in createLeaveRestriction:', error);
		throw new Error(
			error.response?.data?.message_text ||
				error.message ||
				'Failed to create leave restriction',
		);
	}
};

export const updateLeaveRestriction = async (data: {
	restrictLeaveID: number;
	restrictLeaveDate: string;
	Reason: string;
	isPublish?: number;
}) => {
	try {
		const URL = `${API_URL}updateLeaveRestriction`;
		const token = encryptData(data, LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_KEY as any);
		const requestData = { UpdateRestrictedLeaveToken: token } as any;
		return makeApiCall(URL, requestData);
	} catch (error: any) {
		console.error('Error in updateLeaveRestriction:', error);
		throw new Error(
			error.response?.data?.message_text ||
				error.message ||
				'Failed to update leave restriction',
		);
	}
};

export const deleteLeaveRestriction = async (restrictLeaveID: number) => {
	try {
		const URL = `${API_URL}deleteLeaveRestriction`;
		const token = encryptData({ restrictLeaveID }, 'DeleteRestrictedLeaveFromWeb' as any);
		const requestData = { DeleteRestrictedLeaveToken: token } as any;
		return makeApiCall(URL, requestData);
	} catch (error: any) {
		console.error('Error in deleteLeaveRestriction:', error);
		throw new Error(
			error.response?.data?.message_text ||
				error.message ||
				'Failed to delete leave restriction',
		);
	}
};

export const publishLeaveRestriction = async (restrictLeaveID: number) => {
	try {
		const URL = `${API_URL}publishRestrictedLeave`;
		const token = encryptData(
			{ restrictLeaveID },
			LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_KEY as any,
		);
		const requestData = { PublishRestrictedLeaveToken: token } as any;
		return makeApiCall(URL, requestData);
	} catch (error: any) {
		console.error('Error in publishLeaveRestriction:', error);
		throw new Error(
			error.response?.data?.message_text ||
				error.message ||
				'Failed to publish leave restriction',
		);
	}
};

export const unpublishLeaveRestriction = async (restrictLeaveID: number) => {
	try {
		const URL = `${API_URL}unPublishRestrictedLeave`;
		const token = encryptData(
			{ restrictLeaveID },
			LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_KEY as any,
		);
		const requestData = { UnpublishRestrictedLeaveToken: token } as any;
		const response = await axios.post(URL, requestData, {
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			timeout: 30000,
		});
		return response.data;
	} catch (error: any) {
		console.error('Error in unpublishLeaveRestriction:', error);
		throw new Error(
			error.response?.data?.message_text ||
				error.message ||
				'Failed to unpublish leave restriction',
		);
	}
};
